(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["excentric-fluid-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ew-fluid-banner')) {
    class EWFluidBanner extends HTMLElement {
      connectedCallback() {
        // Deferring also supports insertion/reloading in Shopify's theme editor.
        this.mountFrame = requestAnimationFrame(() => this.mount());
      }

      mount() {
        if (!this.isConnected || this.controller) return;
        this.canvas = this.querySelector('canvas');
        this.button = this.querySelector('button');
        if (!this.canvas || !this.button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.seconds = 18;
        this.previousTime = null;
        this.frame = null;
        this.visible = true;
        this.paused = false;
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.tick = this.tick.bind(this);
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
          this.syncPlayback();
        }, options);
        this.motionQuery.addEventListener('change', () => this.syncPlayback(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.canvas.addEventListener('webglcontextlost', event => {
          event.preventDefault();
          this.stop();
          this.program = null;
          this.buffer = null;
          this.dataset.renderer = 'fallback';
          this.button.hidden = true;
        }, options);
        this.canvas.addEventListener('webglcontextrestored', () => this.initializeGraphics(), options);
        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(this);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncPlayback();
        });
        this.visibilityObserver.observe(this);
        this.initializeGraphics();
      }

      initializeGraphics() {
        const gl = this.canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power' });
        if (!gl) { this.dataset.renderer = 'fallback'; return; }
        this.gl = gl;
        const shaders = [];
        let program;
        try {
          const compile = (type, source) => {
            const shader = gl.createShader(type);
            shaders.push(shader);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Shader compilation failed');
            return shader;
          };
          const vertex = compile(gl.VERTEX_SHADER, `
            attribute vec2 a_position;
            void main() { gl_Position = vec4(a_position, 0.0, 1.0); }
          `);
          const fragment = compile(gl.FRAGMENT_SHADER, `
            #ifdef GL_FRAGMENT_PRECISION_HIGH
              precision highp float;
            #else
              precision mediump float;
            #endif
            uniform vec2 u_resolution;
            uniform float u_time;
            uniform float u_intensity;
            uniform vec3 u_color;

            float hash(vec2 p) {
              p = fract(p * vec2(123.34, 345.45));
              p += dot(p, p + 34.345);
              return fract(p.x * p.y);
            }
            float noise(vec2 p) {
              vec2 i = floor(p), f = fract(p);
              f = f * f * (3.0 - 2.0 * f);
              return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), f.x),
                         mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0)), f.x), f.y);
            }
            float fbm(vec2 p) {
              float value = 0.0;
              float amplitude = 0.5;
              mat2 turn = mat2(0.8, -0.6, 0.6, 0.8);
              for (int i = 0; i < 4; i++) {
                value += amplitude * noise(p);
                p = turn * p * 2.03 + 7.1;
                amplitude *= 0.5;
              }
              return value;
            }
            void main() {
              vec2 uv = gl_FragCoord.xy / u_resolution;
              vec2 p = (gl_FragCoord.xy - 0.5 * u_resolution) / u_resolution.y;
              float t = u_time * 0.16;
              vec2 q = vec2(fbm(p * 1.1 + vec2(t * 0.14, 0.0)),
                            fbm(p * 1.1 + vec2(3.7, -t * 0.12)));
              vec2 r = vec2(fbm(p * 1.3 + 2.5 * q + vec2(1.7, t * 0.10)),
                            fbm(p * 1.3 + 2.5 * q + vec2(8.3, -t * 0.13)));
              float f = fbm(p * 1.5 + 2.8 * r + vec2(-t * 0.11, t * 0.08));
              float mist = smoothstep(0.24, 0.76, f);
              float fold = pow(0.5 + 0.5 * sin(12.0 * f + p.x * 1.8 - t * 0.13), 5.0);
              float left = exp(-length((uv - vec2(0.16, 0.65)) * vec2(2.4, 1.2)));
              float right = exp(-length((uv - vec2(0.92, 0.15)) * vec2(3.5, 1.5)));
              float light = (mist * 0.68 + fold * 0.5) * (left + right * 0.55);
              float centerShade = 1.0 - 0.45 * exp(-length(p * vec2(1.8, 1.4)) * 2.5);
              vec3 color = vec3(0.009, 0.003, 0.016);
              color += u_color * light * centerShade * u_intensity * 1.7;
              color += vec3(0.45, 0.16, 0.64) * pow(fold, 3.0) * light * 0.28 * u_intensity;
              float vignette = 1.0 - 0.30 * smoothstep(0.25, 0.8, length(uv - 0.5));
              gl_FragColor = vec4(color * vignette, 1.0);
            }
          `);
          program = gl.createProgram();
          gl.attachShader(program, vertex);
          gl.attachShader(program, fragment);
          gl.linkProgram(program);
          if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Shader linking failed');
          this.program = program;
          gl.useProgram(program);
          this.buffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
          const position = gl.getAttribLocation(program, 'a_position');
          gl.enableVertexAttribArray(position);
          gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
          this.uniforms = {};
          ['u_resolution', 'u_time', 'u_color', 'u_intensity'].forEach(name => { this.uniforms[name] = gl.getUniformLocation(program, name); });
          this.dataset.renderer = 'webgl';
          this.resize();
          this.syncPlayback();
        } catch (error) {
          if (program) gl.deleteProgram(program);
          this.program = null;
          this.dataset.renderer = 'fallback';
          this.button.hidden = true;
        } finally {
          shaders.forEach(shader => gl.deleteShader(shader));
        }
      }

      resize() {
        if (!this.program) return;
        const width = this.canvas.clientWidth, height = this.canvas.clientHeight;
        if (!width || !height) return;
        // Bound GPU work on high-DPI phones and large desktop screens.
        const scale = Math.min(devicePixelRatio || 1, 1.3, 1440 / width, Math.sqrt(850000 / (width * height)));
        this.canvas.width = Math.max(1, Math.round(width * scale));
        this.canvas.height = Math.max(1, Math.round(height * scale));
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
        this.draw();
      }

      draw() {
        if (!this.program) return;
        const gl = this.gl;
        const hex = /^#[0-9a-f]{6}$/i.test(this.dataset.color || '') ? this.dataset.color.slice(1) : '8500df';
        gl.useProgram(this.program);
        gl.uniform2f(this.uniforms.u_resolution, this.canvas.width, this.canvas.height);
        gl.uniform1f(this.uniforms.u_time, this.seconds);
        gl.uniform1f(this.uniforms.u_intensity, this.numberSetting('intensity', 1, 0.2, 1.8));
        gl.uniform3f(this.uniforms.u_color, parseInt(hex.slice(0, 2), 16) / 255, parseInt(hex.slice(2, 4), 16) / 255, parseInt(hex.slice(4, 6), 16) / 255);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }

      numberSetting(name, fallback, min, max) {
        const value = parseFloat(this.dataset[name]);
        return Number.isFinite(value) ? Math.min(max, Math.max(min, value)) : fallback;
      }

      syncPlayback() {
        if (!this.button) return;
        const allowed = this.dataset.animate !== 'false' && !this.motionQuery.matches;
        this.button.hidden = !this.program || !allowed;
        if (this.program && allowed && !this.paused && this.visible && !document.hidden) {
          if (this.frame === null) this.frame = requestAnimationFrame(this.tick);
        } else {
          this.stop();
        }
      }

      tick(now) {
        this.frame = null;
        if (!this.isConnected || !this.program) return;
        if (this.previousTime !== null) this.seconds += Math.min((now - this.previousTime) / 1000, 0.06) * this.numberSetting('speed', 0.7, 0.1, 1.5);
        this.previousTime = now;
        this.draw();
        this.frame = requestAnimationFrame(this.tick);
      }

      stop() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.previousTime = null;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.mountFrame);
        this.stop();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        if (this.gl && this.program) this.gl.deleteProgram(this.program);
        if (this.gl && this.buffer) this.gl.deleteBuffer(this.buffer);
        this.program = null;
        this.buffer = null;
        this.dataset.renderer = 'fallback';
      }
    }
    customElements.define('ew-fluid-banner', EWFluidBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
